let baseUrl
if(process.env.NODE_ENV=="development"){//开发环境接口地址
    baseUrl= "http://192.168.168.123/CPPUJY/WebAPI/"
}else {
    baseUrl= "../WebApi/";
} 
export { baseUrl as default }; 


// WEBPACK FOOTER //
// ./src/assets/js/baseUrl.js